export default __webpack_public_path__ + "static/media/warn.008ee42c.svg";